import { render, staticRenderFns } from "./VulnerabilityInCodeGuest.vue?vue&type=template&id=64313967&scoped=true"
import script from "./VulnerabilityInCodeGuest.vue?vue&type=script&lang=js"
export * from "./VulnerabilityInCodeGuest.vue?vue&type=script&lang=js"
import style0 from "./VulnerabilityInCodeGuest.vue?vue&type=style&index=0&id=64313967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64313967",
  null
  
)

export default component.exports